// extracted by mini-css-extract-plugin
export default {"cancelMessage":"Meetings_cancelMessage__yVpek"};